import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { applyTheme, getTheme } from './theme';
import { initSentry } from './sentry';
import './theme.css';

initSentry(); // no-op without VITE_SENTRY_DSN
// Apply the saved theme before first paint to avoid a flash of the wrong theme.
applyTheme(getTheme());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
